import { default as _91event_id_93JIgxL3XrmyMeta } from "/tmp/build_3dff4878/pages/events/[event_id].vue?macro=true";
import { default as experiencesWQ63ZR40DoMeta } from "/tmp/build_3dff4878/pages/experiences.vue?macro=true";
import { default as indexdoT4bWmnzAMeta } from "/tmp/build_3dff4878/pages/index.vue?macro=true";
import { default as _91meeting_type_id_93c9QupbfIxAMeta } from "/tmp/build_3dff4878/pages/sessions/[meeting_type_id].vue?macro=true";
import { default as indexITIIrqTLRnMeta } from "/tmp/build_3dff4878/pages/sessions/index.vue?macro=true";
import { default as events_45slider_45examplexIoKWDJZQaMeta } from "/tmp/build_3dff4878/pages/widgets/events-slider-example.vue?macro=true";
import { default as events_45sliderOCpgdbikMSMeta } from "/tmp/build_3dff4878/pages/widgets/events-slider.vue?macro=true";
export default [
  {
    name: "events-event_id",
    path: "/events/:event_id()",
    component: () => import("/tmp/build_3dff4878/pages/events/[event_id].vue")
  },
  {
    name: "experiences",
    path: "/experiences",
    meta: experiencesWQ63ZR40DoMeta || {},
    component: () => import("/tmp/build_3dff4878/pages/experiences.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/build_3dff4878/pages/index.vue")
  },
  {
    name: "sessions-meeting_type_id",
    path: "/sessions/:meeting_type_id()",
    component: () => import("/tmp/build_3dff4878/pages/sessions/[meeting_type_id].vue")
  },
  {
    name: "sessions",
    path: "/sessions",
    meta: indexITIIrqTLRnMeta || {},
    component: () => import("/tmp/build_3dff4878/pages/sessions/index.vue")
  },
  {
    name: "widgets-events-slider-example",
    path: "/widgets/events-slider-example",
    meta: events_45slider_45examplexIoKWDJZQaMeta || {},
    component: () => import("/tmp/build_3dff4878/pages/widgets/events-slider-example.vue")
  },
  {
    name: "widget-events-slider",
    path: "/widgets/events-slider",
    meta: events_45sliderOCpgdbikMSMeta || {},
    component: () => import("/tmp/build_3dff4878/pages/widgets/events-slider.vue")
  }
]